import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline, createTheme } from '@mui/material';
import './App.css';
import Login from './pages/Login';
import Home from './pages/Home';
import CreateInstance from './pages/CreateInstance';
import ProtectedRoute from './components/ProtectedRoute';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ErrorPage from './pages/Error';
import RestorePass from './pages/RestorePass';
import Logs from './pages/Logs';

const theme = createTheme();

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/error" element={<ErrorPage />} />
          <Route path="/auth/restore-pass" element={<RestorePass />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Home />} />
            <Route path="/create" element={<CreateInstance />} />
            <Route path="/logs" element={<Logs />} />
          </Route>
          <Route path="*" element={<Navigate to="/error" replace state={{ message: 'Page not found.' }} />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
